/**
 * What went wrong with browser storage, in terms a person can act on. Browsers report these
 * failures with several error names; this turns them into four causes.
 */
export type StorageFailure =
  /** The storage is full. */
  | 'quota'
  /** IndexedDB cannot be used at all (blocked by settings, some private windows, no API). */
  | 'unavailable'
  /** Another tab or the browser holds the database. */
  | 'blocked'
  /** Anything else: I/O errors, corrupted database. */
  | 'failed';

function names(e: unknown): string {
  const out: string[] = [];
  let cur: unknown = e;
  for (let i = 0; i < 4 && cur && typeof cur === 'object'; i++) {
    const o = cur as { name?: unknown; message?: unknown; inner?: unknown; cause?: unknown };
    out.push(String(o.name ?? ''), String(o.message ?? ''));
    cur = o.inner ?? o.cause;
  }
  return out.join(' ');
}

export function classifyStorageError(e: unknown): StorageFailure {
  const s = names(e);
  const code = (e as { code?: unknown } | null)?.code;
  if (/QuotaExceeded|quota|NS_ERROR_DOM_QUOTA|storage is full|disk is full/i.test(s) || code === 22 || code === 1014) return 'quota';
  if (/BlockedError|blocked/i.test(s)) return 'blocked';
  if (/OpenFailed|MissingAPI|SecurityError|InvalidStateError|DatabaseClosed|VersionError|UnknownError.*(backing store|internal error)|IndexedDB API missing|not allowed|denied|insecure/i.test(s)) return 'unavailable';
  return 'failed';
}
